import React from 'react'

var EventFormPaymentContainer = React.createClass({
  onChange: function() {
    function numeric(val) {
      return val.replace(/\D/g,'');
    }

    let change = {
      payment_method: this.refs.payment_method_cheque.checked ? 'cheque' : (this.refs.payment_method_credit.checked ? 'credit_card' : undefined),
      name: this.refs.name ? this.refs.name.value : undefined,
      number: this.refs.number ? numeric(this.refs.number.value) : undefined,
      exp_month: this.refs.exp_month ? numeric(this.refs.exp_month.value) : undefined,
      exp_year: this.refs.exp_year ? numeric(this.refs.exp_year.value) : undefined,
      cvc: this.refs.cvc ? numeric(this.refs.cvc.value) : undefined
    };

    for (var i in change) {
      if (change[i] === null || change[i] === undefined || change[i] === '') {
        delete change[i];
      }
    }

    return this.props.onChange(change)
  },
  render: function() {
    const { admin, onChange, onComplimentaryChange, complimentary, payment_method, name, number, exp_month, exp_year, cvc, subtotal, tax_name, tax, total, readOnly, allow_cheque } = this.props;

    // console.log(this.props);

    const cc_details = <div>
        <div className="form-group">
          <label className="col-lg-2 control-label">Name on Credit Card</label>
          <div className="col-lg-10">
            <input type="text" className="form-control" ref="name" onChange={this.onChange} value={name} />
          </div>
        </div>
        <div className="form-group">
          <label className="col-lg-2 control-label">Credit Card Number</label>
          <div className="col-lg-10">
            <input type="text" className="form-control" ref="number" onChange={this.onChange} value={number} />
          </div>
        </div>
        <div className="form-group">
          <label className="col-lg-2 control-label">Credit Card Expiry</label>
          <div className="col-lg-4">
            <div className="input-group col-sm-8">
              <input type="text" className="form-control" placeholder="MM" maxLength="2" ref="exp_month" onChange={this.onChange} value={exp_month} />
              <span className="input-group-addon">/</span>
              <input type="text" className="form-control" placeholder="YYYY" maxLength="4" ref="exp_year" onChange={this.onChange} value={exp_year} />
            </div>
          </div>
        </div>
        <div className="form-group">
          <label className="col-lg-2 control-label">Credit Card CVC</label>
          <div className="col-lg-2">
            <input type="text" className="form-control" ref="cvc" maxLength="4" onChange={this.onChange} value={cvc} />
          </div>
        </div>
      </div>

    const payment_section = <div>
      <div className="form-group">
        <label className="col-lg-2 control-label">Payment Method</label>
        <div className="col-lg-10">
          <label>
            <input type="radio" name="payment_method" ref="payment_method_cheque" onChange={this.onChange} value='cheque' /> Cheque
          </label>
          <br />
          <label>
            <input type="radio" name="payment_method" ref="payment_method_credit" onChange={this.onChange} value='credit_card' /> Credit Card
          </label>
        </div>
      </div>
    { payment_method != 'credit_card' ? undefined : cc_details }
    </div>

    const payment_section_no_cheque = <div>
      <div className="form-group">
        <label className="col-lg-2 control-label">Payment Method</label>
        <div className="col-lg-10">
          <label>
            <input type="radio" name="payment_method" ref="payment_method_cheque" onChange={this.onChange} value='cheque' disabled /> Cheque (Not Available)
          </label>
          <br />
          <label>
            <input type="radio" name="payment_method" ref="payment_method_credit" onChange={this.onChange} value='credit_card' /> Credit Card
          </label>
        </div>
      </div>
    { payment_method != 'credit_card' ? undefined : cc_details }
    </div>


    return(
      <div className="panel">
        <div className="panel-heading">
          <div className="panel-title"> <span className="glyphicons glyphicons-credit_card"></span> Payment Details </div>
        </div>
        <div className="panel-body">
          <div className="well">
            <div className="form-group">
              <label className="col-lg-2 control-label">Subtotal</label>
              <div className="col-lg-10">
                ${parseFloat(subtotal).toFixed(2)}
              </div>
            </div>
            <div className="form-group">
              <label className="col-lg-2 control-label">{ tax_name ? tax_name : 'Tax' }</label>
              <div className="col-lg-10">
                ${parseFloat(tax).toFixed(2)}
              </div>
            </div>
            <div className="form-group">
              <label className="col-lg-2 control-label">Total</label>
              <div className="col-lg-10">
                ${parseFloat(total).toFixed(2)}
              </div>
            </div>
          </div>

          { readOnly ? undefined : (allow_cheque ? payment_section : payment_section_no_cheque) }
          { admin.isAdmin ?
          <div className="form-group">
            <label className="col-lg-2 control-label">ADMIN</label>
            <div className="col-lg-10">
              <label>
                <input type="checkbox" name="admin_bypass_payment" ref="admin_bypass_payment" checked={complimentary} onChange={ (e) => onComplimentaryChange(e.target.checked) } value={1} /> Mark as complimentary (bypass payment)
              </label>
            </div>
          </div>
          : undefined }
        </div>
      </div>
    );
  }
});

export default EventFormPaymentContainer;


// WEBPACK FOOTER //
// ./src/components/event_form_payment_container.js